import { get, isArray, isNil, isPlainObject, mapValues } from 'lodash/fp';
import { combineReducers } from 'redux';

import { createReducer } from '@mews/framework';

import { DEFAULT_CONFIGURATION, DEFAULT_HOTEL_CONFIGURATION } from '../../constants';
import { CONFIGURATION_SET, PRIMARY_COLOR_SET, THEME_VARIANT_SET } from './actionTypes';

const initialState = DEFAULT_CONFIGURATION;

const mapValuesWithKey = (mapValues as $TSFixMe).convert({ cap: false });
const updateExistingData = (target: $TSFixMe, source: $TSFixMe) =>
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    source
        ? mapValuesWithKey((targetValue: $TSFixMe, key: $TSFixMe) => {
              const sourceValue = source[key];

              if (isNil(sourceValue) || (isArray(targetValue) && !isArray(sourceValue))) {
                  return targetValue;
              }

              if (isPlainObject(targetValue)) {
                  return updateExistingData(targetValue, sourceValue);
              }

              return sourceValue;
          }, target)
        : target;

const appReducer = createReducer(initialState.app, {
    [CONFIGURATION_SET]: (state: $TSFixMe, { app }: $TSFixMe) => updateExistingData(state, app),
});

const settingsReducer = createReducer(initialState.settings, {
    [CONFIGURATION_SET]: (state: $TSFixMe, { settings }: $TSFixMe) => updateExistingData(state, settings),
});

const hotelsReducer = createReducer(initialState.hotels, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [CONFIGURATION_SET]: (state, { hotels }: $TSFixMe) => ({
        ...state,

        ...mapValuesWithKey(
            (hotel: $TSFixMe, key: $TSFixMe) =>
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                updateExistingData(get(key, state) || DEFAULT_HOTEL_CONFIGURATION, hotel),
            hotels
        ),
    }),
});

const themeReducer = createReducer(initialState.theme, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [CONFIGURATION_SET]: (state, { theme = {} }) => ({
        ...state,
        ...theme,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [PRIMARY_COLOR_SET]: (state, { primaryColor }: $TSFixMe) => ({
        ...state,
        primaryColor,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [THEME_VARIANT_SET]: (state, { variant }: $TSFixMe) => ({
        ...state,
        variant,
    }),
});

export const configurationReducer = combineReducers({
    app: appReducer,
    hotels: hotelsReducer,
    settings: settingsReducer,
    theme: themeReducer,
});
